import React, { useRef, useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { toast } from 'react-toastify';

import { get } from 'lodash';

import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { isArray, isEmpty } from 'lodash';
import * as Yup from 'yup';

import Tabela from '../Tabela';

import { Table } from '~/components';

import { Form, Input, Autocomplete } from '~/components/Form'
import { t } from '~/helpers';
import api from '~/services/api';

import qs from 'querystring';

import * as S from './styles';


import {
  deleteoperacaobloqueioprefaturageradaitem,
  recordFilteringVeiculo,
  findVeiculosBloqueadosPreFaturaGerada,
  veiculosBloqueadosPreFaturaGeradaInRequest,
} from '~/store/modules/operacaobloqueioprefaturageradaitem/actions';

export default function DetalhePreFaturaGerada({ data }) {
  const formRef = useRef(null);

  // const operacaobloqueioprefaturageradaitem = useSelector(
  //   (state) => state.operacaobloqueioprefaturageradaitem
  // );

  const [itemSelecionado, setItemSelecionado] = React.useState({});
  const [itemPreFatura, setItemPreFatura] = useState([]);
  const [itensFaturaVeiculoHistorico, setItensFaturaVeiculoHistorico] = useState([]);

  const [loading, setLoading] = useState(false);

  const handleGetItemPreFatura = useCallback(async () => {
    try {

      let params = {};

      let dadosItemPreFatura = [];

      params = {
        fieldlist: 'fatu_codigo, veic_placa, ftit_fatura_str',
        wherefield: ['fatu_codigo'],
        typewherefield: ['EQUALS'],
        valuewherefield: [data.fatu_codigo],
        orderfield: 'veic_placa',
        pagesize: 99999,
      }

      const responseItens = await api.get('operacaobloqueioprefaturageradaitemhistoricoitem', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });

      dadosItemPreFatura = responseItens.data.items;

      setItemPreFatura(dadosItemPreFatura);


      //const response = await api.get(`cotaunidade/${unity.unid_codigo}/${unity.orga_codigo}/${product}`);

      // if (!isEmpty(response.data)) setBalance(response.data.coun_cota);
      // else setBalance(0);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data]);


  const handleGetItemPreFaturaVeiculoHistorico = useCallback(async (fatu_codigo, veic_placa) => {
    try {

      let params = {};

      let dadosItemPreFaturaVeiculoHistorico = [];

      params = {
        fieldlist: 'apbf_data_evento_str, apbf_acao_str,apbf_login_executante,apbf_observacao',
        wherefield: ['fatu_codigo', 'veic_placa'],
        typewherefield: ['EQUALS', 'EQUALS'],
        valuewherefield: [fatu_codigo, veic_placa],
        orderfield: 'apbf_data_evento',
        pagesize: 99999,
      }

      const responseItensHistorico = await api.get('operacaobloqueioprefaturageradaitemhistoricoitem/veiculosbloqueadosHistorico', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });

      dadosItemPreFaturaVeiculoHistorico = responseItensHistorico.data.items;

      setItensFaturaVeiculoHistorico(dadosItemPreFaturaVeiculoHistorico);


      //const response = await api.get(`cotaunidade/${unity.unid_codigo}/${unity.orga_codigo}/${product}`);

      // if (!isEmpty(response.data)) setBalance(response.data.coun_cota);
      // else setBalance(0);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data]);

  useEffect(() => {
    handleGetItemPreFatura();
  }, [data]);

  // useEffect(() => {
  //   if (product && !isEmpty(unity)) handleGetBalance();
  // }, [product, unity]);


  const header = [
    {
      id: 'veic_placa',
      label: 'Veículo',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'ftit_fatura_str',
      label: 'Estado',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
  ];



  const headerDetalheVeiculo = [
    {
      id: 'apbf_data_evento_str',
      label: 'Data',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'apbf_acao_str',
      label: 'Status',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'apbf_login_executante',
      label: 'Login',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'apbf_observacao',
      label: 'Observação',
      filter: {
        type: 'text',
      },
      align: 'center',
    },
  ];

  const registroSelecionado = React.useCallback((values) => {

    if ((values)) {
      let item = { ...values };


      setItemSelecionado(item);

      handleGetItemPreFaturaVeiculoHistorico(item.fatu_codigo, item.veic_placa);
    } else {
      setItensFaturaVeiculoHistorico([]);
    }

  }, [data, itemPreFatura]);

  return (
    //<Form ref={formRef} onSubmit={handleSubmit} initialData={data}>
    <S.Wrapper>

      <S.WrapperCabecalho>
        <p>
          {/* //Pré-fatura..: {(data.fatu_codigo !== undefined ) ? data.fatu_codigo:''} */}
          Pré-fatura..: {get(data,'fatu_codigo','')}
        </p>
        {/* </S.WrapperCabecalho>
      <S.WrapperCabecalho> */}
        <p>
          Órgão..........: {get(data,'orga_sigla','')}
          {/* Órgão..........: {(data.orga_sigla !== undefined) ? data.orga_sigla: ''} */}
        </p>
      </S.WrapperCabecalho>

      <Tabela
        loading={loading}
        cells={header}
        data={itemPreFatura}
        size="small"
        showPagination={true}
        showCount
        search
        paginate={8}
        onCallback={(values) => registroSelecionado(values)}
        onCallbackNewPage={(values) => registroSelecionado(values)}

      //onCallback={(values) => registroSelecionado(values)}
      />

      <Table
        title={'Veículo Histórico'}
        loading={loading}
        cells={headerDetalheVeiculo}
        data={itensFaturaVeiculoHistorico}
        size="small"
        //showPagination={true}
        showCount
        //search
        paginate={5}
      />

      {/* <Tabela
        noReset
        read={veiculosBloqueadosPreFaturaGeradaInRequest}
        remove={deleteoperacaobloqueioprefaturageradaitem}
        state={operacaobloqueioprefaturageradaitem}
        header={header}
        noCreate
        noEdition
        headerMobile="fatu_codigo"
        unique={['fatu_codigo', 'veic_placa']}
        findItem={findVeiculosBloqueadosPreFaturaGerada}
        recordFilter={recordFilteringVeiculo}
        //buttons={buttons}
        customFilter={[
          // {
          //   id: 'veic_placa',
          //   name: 'Veículo',
          //   label: 'Veículo',
          //   type: 'text',
          // },
        ]}
        query={{
          wherefield: ['fatu_codigo', 'veic_placa'],
          valuewherefield: [data.fatu_codigo, data.veic_placa],
          typewherefield: ['EQUALS'],
        }}
      /> */}

    </S.Wrapper>
    //</Form>
  );
}

DetalhePreFaturaGerada.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
}
